import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import map from 'lodash/map';
import LazyLoad from 'react-lazyload';

import { Image } from 'shared/lib/SureDesignSystem';

import styles from './BuiltForEnterprise.module.css';

const propTypes = {
  className: PropTypes.string,
};
const defaultProps = {
  className: null,
};

const sections = [
  {
    title: 'Product Selection',
    description:
      'We offer a broad selection of insurance products for consumers and businesses.',
    pattern: require('./assets/state.png'),
    patternWebp: require('./assets/state.webp'),
  },
  {
    title: 'Global Footprint',
    description: 'Our solutions work in all 50 states and global markets.',
    pattern: require('./assets/licensed.png'),
    patternWebp: require('./assets/licensed.webp'),
  },
  {
    title: 'Partner Success',
    description:
      'All partners receive hands-on resources to make getting started easy.',
    pattern: require('./assets/collaborate.png'),
    patternWebp: require('./assets/collaborate.webp'),
  },
  {
    title: 'Customize & Launch',
    description:
      'Select from various integration options and customer experiences.',
    pattern: require('./assets/launch.png'),
    patternWebp: require('./assets/launch.webp'),
  },
  {
    title: 'Trust & Security',
    description: 'Bank-grade security keeps the information safe.',
    pattern: require('./assets/security.png'),
    patternWebp: require('./assets/security.webp'),
  },
  {
    title: 'Customer Support',
    description:
      'Telephone and email support available any time for your customers.',
    pattern: require('./assets/support.png'),
    patternWebp: require('./assets/support.webp'),
  },
];

class BuiltForEnterprise extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeSectionIndex: 0,
    };
  }

  onSectionFocus = (section, index) => () => {
    this.setState({
      activeSectionIndex: index,
    });
  };

  render() {
    const { className } = this.props;
    const { activeSectionIndex } = this.state;

    return (
      <div className={classnames(styles.wrapper, className)}>
        <div className={styles.bg1} />
        <div className={styles.bg2} />
        <div className={styles.container}>
          <div className={styles.patternsWrapper}>
            {map(sections, (section, i) => (
              <LazyLoad height={400} once>
                <Image
                  key={i}
                  className={classnames(styles.pattern, {
                    [styles.isActive]: activeSectionIndex === i,
                  })}
                  src={section.pattern}
                  webp={section.patternWebp}
                  pictureClassName={styles.patternsWrapperPicture}
                />
              </LazyLoad>
            ))}
          </div>
          <div className={styles.contentWrapper}>
            <h2 className={styles.title}>Insurance-as-a-Service (IaaS)</h2>
            <div className={styles.sections}>
              {map(sections, (section, i) => (
                <div
                  key={i}
                  className={classnames(styles.section, {
                    [styles.isActive]: activeSectionIndex === i,
                  })}
                  onMouseOver={this.onSectionFocus(section, i)}
                >
                  <h3 className={styles.sectionTitle}>{section.title}</h3>
                  <p className={styles.sectionDescription}>
                    {section.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BuiltForEnterprise.propTypes = propTypes;
BuiltForEnterprise.defaultProps = defaultProps;

export default BuiltForEnterprise;
